import BaseModal from 'components/BaseModal';
import { MODAL_SIZE_LARGE, SEVERITY_COLOR } from 'constants/Layout';
import React, { forwardRef, useCallback, useEffect, useState, useMemo, useRef, useImperativeHandle } from 'react'
import { checkCharLimit, CUSTOM_FIELDS_SINGLE_SELECTION, CUSTOM_FIELDS_WITH_OPTIONS, CUSTOM_FIELDS_WITH_SEARCH, CUSTOM_FIELDS_WITH_USER_API, CUSTOM_FIELD_TYPE, FieldTypes, generateFormFields, getCustomFieldValue, TIME_SUPPORTED_DATE_FIELDS, ALL_DATE_FIELDS } from 'utils/formUtils';
import Vocabulary, { getVocabulary } from 'components/Vocabulary';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import message from "components/CustomMessage";
import { Form, Tooltip, Typography, Alert, Spin, Input, TreeSelect } from 'antd';
import TicketsCreationAPI from "restAPI/TicketsCreationAPI";
import _, { isEmpty ,isArray, isNil, isString} from 'lodash';
import { SEVERITY_NAMES } from 'views/Findings/Constants';
import { HelpIcon, InfoIcon } from 'components/Icons';
import CustomCollapse from "components/CustomCollapse";
import { isUndefined } from 'utils/lodashUtils';
import AppLoader from 'components/AppLoader';
import moment from 'moment';
import ModalUtil from 'utils/modalUtil'
import { toolsUsingValueFromCustomFields } from './JiraListingNew';
import WebhookUrlSuccess from './WebhookUrlSuccess';
import { DEFAULT_VALUES_VERSION_ONE } from '../VersionOne/VersionOneMappingForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import { disablePastDates } from 'utils/dateUtils';
import { hasPermission } from 'utils/authService';
import { PermissionSetMap } from 'constants/RBACConstants';
import { CUSTOM_FIELDS_RISK_RATING_MAPPING_KEYS, CUSTOM_FILED_SUPPORTED_INTEGRATIONS, CONFIG_UPDATE_WARNING_MESSAGE, CUSTOM_SEVERITY_MAPPING_SUPPORTED_TOOLS } from '../genericIntegrationTicketConstants';
import { ResolvedFindingStatusNames, useUnifiedMultiTemplateOptions, useUnifiedSingleTemplateOptions, generateJiraCustomFields, getSeverityFieldMappingsPayload, integrationTicketingToolsProductOptionsMutator, getCustomFieldSelectedValuesPayload } from '../genericIntegrationTicketUtils';
import { findingFieldValidator } from '../TicketTemplateForm';
import { parseAreaOptions } from '../azureBoard/AzureBoardMappingForm';
import { RENDER_FIELDS_V2 } from '../CustomFields/customFieldsMap';

const {Link} = Typography

const DEFAULT_VALUES = { 
    product: "all", 
    subProduct: ["all"], 
    critical:"Highest",
    high:"High",
    medium:"Medium",
    low:"Low",
    info:"Lowest",
    defaultConfiguration: false,
};

const PAGER_DUTY_DEFAULT_VALUES = { 
    product: "all", 
    subProduct: "all", 
    critical:"High",
    high:"High",
    medium:"Low",
    low:"Low",
    info:"Low"
}

export function getDefaultData(data = {},name){
    const { customFields } = data;
    _.forEach(customFields, field => {
        data[field.key] = getCustomFieldValue(field.type,field.defaultVal)
        if(name === "Service Now" && field.key === "assignmentGroup"){
            data.assignmentGroup = JSON.parse(field.value)?.name;
        }
        if(toolsUsingValueFromCustomFields.includes(name)){
            //check workspace only for Rally
            if(name === "Rally" && field.key === "workspace"){
                data.organisation = field.value;
            }
            if(name === "Version One"){
                if(field.key === "teamValue"){
                    data.team = field.value;
                }
                if(field.key === "issueTypeValue"){
                    data.issueType = field.value;
                }
            }
            if(field.key === "projectValue"){
                data.projectKey = field.value;
            }
        }
    })
    data = {
        ...data,
        labels: data?.labels || ["Armorcode_Associated_Finding"],
        subProduct: !isEmpty(data?.subProductIds) ? data?.subProductIds : ["all"],
        product: !isEmpty(data?.product) ? data?.product : ["all"],
        ...data.properties,
        ...(data.transitions ? {transitions:JSON.stringify(data.transitions)} : {})
    };
    const defaultValues = name === "PagerDuty" ? PAGER_DUTY_DEFAULT_VALUES : (name === 'Version One' ? DEFAULT_VALUES_VERSION_ONE : DEFAULT_VALUES);
    
    const d = { ...defaultValues };
    Object.keys(data).forEach(key => {
        if(_.isPlainObject(data[key]) && data[key].id){
            d[key] = data[key].id;
        } else if(data?.[key]){
            d[key] = data?.[key];
        }
    });
    return d;
}

const serviceNowModulesOptions = [{label:"Incident", value: "incident"},{label: "Vulnerability Response", value: "Vulnerability Response"}];

const JiraMappingForm = ({loginConfigId, onUpdateConfigComponent, name, displayName, url = undefined, ...props}, ref) => {
    const [initialData] = useState(() => getDefaultData(props.config,name));
    const isEdit = Boolean(props.config?.id);
    const [form] = Form.useForm();
    const [data, setData] = useState(initialData);
    const [transitionStatusOptions, setTransitionStatusOptions] = useState([]);
    const debounceSetData = _.debounce(setData,300);
    const [priorities, setPriorities] = useState([]);
    const [isResolvedStatusDisabled, setIsResolvedStatusDisabled] =  useState(!data.markResolved);
    const [markReopen, setMarkReopen] = useState(data.markReopen)
    const [isWebhookSync, setIsWebhookSync] = useState(data.webHookEnabled);
    const [allSelected, setAllSelected] = useState(false);
    const featureFlags = useFeatureFlag();
    const {getUnifiedSingleTemplates, unifiedSingleDefaultTemplate} = useUnifiedSingleTemplateOptions();
    const {getUnifiedMultiTemplates, unifiedMultiDefaultTemplate} = useUnifiedMultiTemplateOptions();
    const filteredIntegrations = useMemo(() => _.compact(_.map(CUSTOM_FILED_SUPPORTED_INTEGRATIONS, (entry) => {
        if ((entry.featureFlag && featureFlags[entry.featureFlag]) || !entry.featureFlag) {
            return entry.tool;
        }
        return null;
    })), [featureFlags]);
    const isServiceNowDetConfig = name === "Service Now"
        && featureFlags.SNOW_VR_DETECTIONS
        && data.projectKey === "Vulnerability Response"
        && data.issueType === "sn_vul_detection";

    const thisRef = useRef();
    const [isCustomFieldsLoading, setIsCustomFieldsLoading] = useState(false);
    const [editRepoMapping] = useState(()=>{
        let selectedRepo = [];
        if(name === "GitLab Issues" && !_.isEmpty(props.config?.customFields)){
           const { customFields } = props.config;
           selectedRepo = [{id: customFields[0].value, name: customFields[0].name}];
        }
        return selectedRepo;
    });
    const repoNamesRef = useRef(editRepoMapping);
    const workspacesRef = useRef();
    const projectKeyRef = useRef(props.config?.configMetaData?.projectMetaData
        ? 
            {
              name: props.config.configMetaData.projectMetaData.name,
              id: props.config.configMetaData.projectMetaData.id,
            }
        : {});
    useEffect(() => {
        if(typeof name !== 'string' || !['jira', 'service now', 'rally'].includes(name.toLowerCase())){
            return;
        }
        let cancelTransionStatusApi = _.noop;
        const getTransitionStatusOptions = async () => {
            if(!loginConfigId || !data.issueType || !data.projectKey){
                return false;
            }
            const requestPayload = {
                loginConfigId,
                issueType: data.issueType,
                projectKey: data.projectKey,
                organisation: data.organisation
            }
            const {promise: transitionStatusPromise, cancel: transitionStatusReject} = ToolsIntegrationsAPI.getJiraCloseTransitionStatusOptions(requestPayload);
            cancelTransionStatusApi = transitionStatusReject;
            const statusOptions = await transitionStatusPromise;
            cancelTransionStatusApi = _.noop;
            setTransitionStatusOptions(statusOptions);
        }

        getTransitionStatusOptions();
        return cancelTransionStatusApi;
    },[loginConfigId,data.issueType,data.projectKey,name, data.organisation]);

    useEffect(() => {
        if(allSelected){
            form.setFieldsValue({ticketClosureStatus: ['All']})
        }
    }, [allSelected, form]);

    const getWorkspaces = useCallback(
        () => {
          if(!loginConfigId){
              return Promise.resolve([]);
          }
          const promiseObj  = ToolsIntegrationsAPI.getWorkspaces(loginConfigId);
          promiseObj.promise.then((res)=>{workspacesRef.current = res});
          return promiseObj;
        },
        [loginConfigId],
      )
    
    const onOk = async() => {
        await form.validateFields();
        const toolName = name.toUpperCase().replace(' ', '_');
        const data = form.getFieldsValue();
        if (isServiceNowDetConfig) {
            data.critical = undefined;
            data.high = undefined;
            data.medium = undefined;
            data.low = undefined;
            data.info = undefined;
            data.markResolved = false;
            data.resolvedStatus = undefined;
            data.markReopen = false;
            data.reopenStatus = undefined;
        }
        data.ticketClosureStatus = _.isEmpty(data.ticketClosureStatus) ? null : data.ticketClosureStatus;
        data.webhook = data.webHookEnabled
        delete data.webHookEnabled
        data.customFields = [];

        if(name.toLowerCase() === "rally"){
            const workspace = _.find(workspacesRef.current, workspace => workspace.id === data.organisation);
            if(!_.isEmpty(workspace)){
                data.customFields.push({key:"workspace", value: workspace.id, name: workspace.name});
            }
        }
        if (toolsUsingValueFromCustomFields.includes(name)) {
            const currentRepo = _.find(repoNamesRef.current, (repo) => repo.id === data.projectKey);

            if (currentRepo) {                
                data.customFields.push({
                    key: "projectValue",
                    type: "textfield",
                    dataType: "string",
                    name: currentRepo.name,
                    value: currentRepo.id
                })
            }
        }
        
        const configValues = await generateResponse(data, props.config?.id, loginConfigId, url, toolName, thisRef.current?.getCustomFields(), featureFlags);

        if (!isEmpty(projectKeyRef.current)) {
            configValues.configValues = {
              ...configValues.configValues,
              metaData: {
                projectMetaData: {
                  id: projectKeyRef.current.id,
                  name: projectKeyRef.current.name,
                },
              },
            };
          }

        if(!_.isPlainObject(configValues)){
            return Promise.reject("Mapping already exist");
        }
        if(name.toLowerCase() === "jira" && !configValues.isDefaultConfigPresent){
            message.warn("Default configuration does not exist, mark one of them as default");
        }
        const { webHookUrl } = await ToolsIntegrationsAPI[!isEdit ? "integrateTicketSystemTool" : "updateTicketSystemToolMapping"](configValues.configValues, props.config?.id).promise;
        message.success(`${name} Mapping saved`);
        onUpdateConfigComponent && onUpdateConfigComponent(false);
        if(data.manualRegister && webHookUrl){
            ModalUtil.show({
                content: <WebhookUrlSuccess url={webHookUrl} />
            });
        }
        
    }

    const onChange = (values) => {
        thisRef.current?.onFieldValuesChange?.(values);
        const formData = {...data};
        //Don't reset the severity default fields for PagerDuty
        if(values.projectKey && name !== "PagerDuty"){
            form.setFieldsValue({
                critical: undefined, high: undefined, medium: undefined, low: undefined, info: undefined
            })
        }

        if( !isUndefined(values.projectKey) && values.projectKey !== data.projectKey){
            form.setFieldsValue({issueType:null})
            formData["issueType"] = null
        }

        let onChangeHandler = setData;
        if(values.markResolved === false){
            form.setFieldsValue({resolvedStatus: initialData.resolvedStatus, reopenStatus: initialData.reopenStatus});
        }
        const shouldHideNextServiceNowDetFindingControls = name === "Service Now"
            && featureFlags.SNOW_VR_DETECTIONS
            && (values.projectKey ?? data.projectKey) === "Vulnerability Response"
            && (values.issueType ?? formData.issueType) === "sn_vul_detection";
        if(shouldHideNextServiceNowDetFindingControls){
            form.setFieldsValue({
                markResolved: false,
                resolvedStatus: undefined,
                markReopen: false,
                reopenStatus: undefined,
                critical: undefined,
                high: undefined,
                medium: undefined,
                low: undefined,
                info: undefined,
            });
            formData.markResolved = false;
            formData.resolvedStatus = undefined;
            formData.markReopen = false;
            formData.reopenStatus = undefined;
            setIsResolvedStatusDisabled(true);
            setMarkReopen(false);
        }
        if(typeof values.projectKey !== 'undefined' && name === 'Service Now'){
            onChangeHandler = debounceSetData;
        }
        onChangeHandler({...formData, ...values});
    }

    const appendAll = useCallback((list) => ([{ label: "All", value: "all" }, ...(list || [])]), []);

    const onCreateSubproduct = useCallback((createdSubproduct) => {
        const subProductValues = form.getFieldValue("subProduct");
        form.setFieldsValue({
          subProduct: [...subProductValues, createdSubproduct.id],
        });
        setData((prevdata) => ({ ...prevdata, subProduct: [...subProductValues, createdSubproduct.id]}));
      }, [form]);
    
    const getIssueTypes = useCallback(() => {
        if(!data.projectKey) {
            return Promise.resolve([])
        }
        return ToolsIntegrationsAPI.getTicketSystemToolIssueTypes({projectKey: data.projectKey, loginConfigId});
    }, [data.projectKey, loginConfigId])

    const getProjectKeys = useCallback(()=>{
        if(name.toLowerCase() === "rally" && !data.organisation){
            return Promise.resolve([]);
        }
        const { promise, cancel } = ToolsIntegrationsAPI.getTicketSystemToolProjects(loginConfigId, {organisation: data.organisation});

        promise.then(res => repoNamesRef.current = res);
        return { promise, cancel }
    },[loginConfigId, data.organisation, name])

    const getJiraProjectKeys = useCallback((params)=>{
        const { promise, cancel } = ToolsIntegrationsAPI.getTicketSystemToolProjects(loginConfigId, params);
        return { promise, cancel }
    },[loginConfigId])

    useEffect(() => {
        //PagerDuty severity fields are not being fetched from priorities api
        //No need to reset the priorites field
        // when TICKETING_CUSTOM_SEVERITY_RISK_RATING FF is enabled priority fields will be configured in custom fields for Jira and Azure Board
        if(featureFlags.TICKETING_CUSTOM_SEVERITY_RISK_RATING && CUSTOM_SEVERITY_MAPPING_SUPPORTED_TOOLS.includes(name.toLowerCase())){
            return;
        }
        if(name === "Service Now" && (!data.projectKey || !data.issueType)){
            return;
        }
        if( data.projectKey && ((name === "Jira" && data.issueType ) ||  (name !== "PagerDuty" && name !== "Jira"))) {
            setPriorities([]);
            const { cancel, promise } = ToolsIntegrationsAPI.getTicketSystemToolPriorities({ projectKey: data.projectKey, 
            issueType: data.issueType,loginConfigId, ...(data.organisation && {organisation: data.organisation}) });
            promise.then((response) => {

                if(!(isEdit && (data.projectKey === initialData.projectKey))){
                    const severities = {};
                    const severityNames = Object.keys(SEVERITY_NAMES);
                    response.forEach((entry, index) => {
                        severities[severityNames[index]] = entry.id;
                    });

                    if(severityNames.length > response.length){
                        for(let index = response.length; index < severityNames.length; index++){
                            severities[severityNames[index]] = severities[severityNames[index - 1]];
                        }
                    }
                   form.setFieldsValue( severities);
                }
                setPriorities(response);
            });
            return cancel;
        }
    }, [isEdit,data.projectKey,data.issueType,loginConfigId, form,initialData.projectKey, name, data.organisation, featureFlags.TICKETING_CUSTOM_SEVERITY_RISK_RATING])

    useEffect(() => {
        if(!isEdit){
            form.setFieldsValue({ticketUnifiedSingleTemplateId: unifiedSingleDefaultTemplate, ticketUnifiedMultipleTemplateId: unifiedMultiDefaultTemplate});
        }
    }, [isEdit, form, unifiedSingleDefaultTemplate, unifiedMultiDefaultTemplate]);

    const resetSubProductsFiled = useCallback((values, field) => {
        setData(data => ({ ...data, product: values }));
        form.setFieldsValue({subProduct:["all"]});
    },[form]);

    const commonSeverityProps = useMemo(() =>({
        colSpan: 5,
        className: "m-b-0",
        type: FieldTypes.SELECT,
        style: {flex: "0 0 20%"},
        rules: [{
            required: true,
            message: `Select ${name} Priority`
        }],
        options: priorities,
        loading: data.projectKey && _.isEmpty(priorities),
        disabled: !data.projectKey,
    }),[data.projectKey, name, priorities])

    const modalProps = {
        title: `${isEdit ? "Edit" : "Add"} ${displayName || name} Mapping`,
        width: MODAL_SIZE_LARGE,
        onOk,
        disabled: !hasPermission(isEdit ? PermissionSetMap.EDIT_TOOL_CONFIG : PermissionSetMap.WRITE_TOOLS) || isCustomFieldsLoading,
    }

    // if more than one product or All product is selected then subproduct should be disabled
    // this would work as previous, just will get the product id from array, as product is multi select
    const productId = data.product && data.product[0] !== "all" ? data.product[0] : null;

    const subProductOptionsMutator = useCallback((options) => {
        const updatedOptions = appendAll(options);
        const selectedValues = form.getFieldValue("subProduct") || [];
        const isAllSelected = selectedValues.includes("all");
        return updatedOptions.map((option) => ({
            ...option,
             disabled: isAllSelected && option.value !== "all"
            }));
    }, [appendAll, form]);

    const onCreateProduct = useCallback((createdProduct) => {
        const productsAfterCreate = [...form.getFieldValue("product"), createdProduct.id];
        form.setFieldsValue({
            product: productsAfterCreate,
            subProduct: ["all"],
        });
        setData((data) => ({ ...data, product: productsAfterCreate, subProduct: ["all"] }))
    }, [form])

    const productSubProductFields = useMemo(() =>([{
        name: "product",
        label: <Vocabulary name="product" />,
        type: FieldTypes.PROD_SUBPROD_SELECT_ADD,
        required: true,
        colSpan: 12,
        // disabled:isEdit,
        props: {
            dropdownType: 'product',
            showAddButton: true,
            optionsMutator: (options) => integrationTicketingToolsProductOptionsMutator(options, form.getFieldValue("product")),
            onChange: resetSubProductsFiled,
            onCreate: onCreateProduct,
            mode: "multiple",
        }
    }, {
        name: "subProduct",
        label: <Vocabulary name="subProduct" />,
        type: FieldTypes.PROD_SUBPROD_SELECT_ADD,
        required: true,
        colSpan: 12,
        disabled: data.product && data.product.length > 1,
        props: {
            productId: productId,
            showAddButton: Boolean(productId),
            dropdownType: 'subProduct',
            onCreate: onCreateSubproduct,
            onChange: (values) => {
                if (values.includes("all")) {
                  form.setFieldsValue({subProduct: ["all"]});
                }
              }, 
              optionsMutator: subProductOptionsMutator,
            mode: "multiple"
        }   
    }]),[form, productId, resetSubProductsFiled, onCreateSubproduct, subProductOptionsMutator, data.product, onCreateProduct]);

    const parseJiraProjectKeyOptions = useCallback((options) => {
        const updatedOptions = customParseSelectOptions(options);
            if (!isEmpty(projectKeyRef.current)) {
              return _.uniqBy(
                [
                  ...updatedOptions,
                  {
                    label: projectKeyRef.current.name,
                    value: projectKeyRef.current.id,
                  },
                ],
                "value",
              );
            }
            return updatedOptions;
    }, [])


    const fields = useMemo(() => ([
        ...productSubProductFields,
        {
            name: "projectKey",
            label: "Project Key",
            colSpan: 12,
            type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
            required: true,
            props: {
                api: getJiraProjectKeys,
                parseSelectOptions: parseJiraProjectKeyOptions,
                onChange: (value, listField, selectedOption) => {
                    isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                    projectKeyRef.current = {
                        id: selectedOption.id,
                        name: selectedOption.value
                    }
                    setData({...data, projectKey: value, issueType: undefined });
                    form.setFieldsValue({ issueType: undefined });
                }
            }
        }, {
            name: "issueType",
            label: "Issue Type",
            colSpan: 12,
            type: FieldTypes.SELECT,
            required: true,
            disabled: !data.projectKey,
            props: {
                api: getIssueTypes,
                parseSelectOptions: customParseSelectOptions,
                onChange: (value) =>  {
                    isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                    const markResolved = form.getFieldValue('markResolved');
                    setData({...data, issueType: value});
                    setIsResolvedStatusDisabled(!value || !markResolved);
                }
            }
        },
        ...(name ==="Jira") ?
        [{
            name: "defaultConfiguration",
            label: "Set as Default Project Key",
            inline: true,
            help: <>Use the Jira project as default for the given <Vocabulary name="product"/> and/or <Vocabulary name="subProduct"/> while creating tickets manually or through runbooks.</>,
            type: FieldTypes.BOOLEAN,
        }, ...(featureFlags.UNIFIED_TICKET_TEMPLATE ? [{
            name: "ticketUnifiedSingleTemplateId",
            label: "Single Finding Template",
            colSpan: 12,
            type: FieldTypes.SELECT,
            props: {
                api: getUnifiedSingleTemplates,
            }
        }, {
            name: "ticketUnifiedMultipleTemplateId",
            label: "Multi-Finding Template",
            colSpan: 12,
            type: FieldTypes.SELECT,
            props:{
                api: getUnifiedMultiTemplates,
            }
        }] : [])] : [], 
        ...(featureFlags.TICKETING_CUSTOM_SEVERITY_RISK_RATING && CUSTOM_SEVERITY_MAPPING_SUPPORTED_TOOLS.includes(name.toLowerCase()) ? [] : name ==="Jira" && data.projectKey && data.issueType && _.isEmpty(priorities) ? [{
            name: '',
            label: '',
            render: () => <Alert type="info" className='m-b-xs' showIcon message={`The Jira Priority field is not available as part of ${data.issueType} for ${data.projectKey}. The findings severity mapping will not be supported.`} />
        }] : []),
        ...(featureFlags.TICKETING_CUSTOM_SEVERITY_RISK_RATING && CUSTOM_SEVERITY_MAPPING_SUPPORTED_TOOLS.includes(name.toLowerCase()) ? [] : data.projectKey && !_.isEmpty(priorities) ?
        [{
            label:<>ArmorCode Severity {"->"} {name} Priority {name === "Jira" && <Tooltip title="The mapping for the project must match the priorities provided by Jira."><span><InfoIcon/></span></Tooltip>}</>,
            type: FieldTypes.GROUP,
            fields: [{
                name: "critical",
                label: <Vocabulary name="critical"/>,
                ...commonSeverityProps
            }, {
                name: "high",
                label: <Vocabulary name="high"/>,
                ...commonSeverityProps
            }, {
                name: "medium",
                label: <Vocabulary name="medium"/>,
                ...commonSeverityProps
            }, {
                name: "low",
                label: <Vocabulary name="low"/>,
                ...commonSeverityProps
            }, {
                name: "info",
                label: <Vocabulary name="info"/>,
                ...commonSeverityProps
            }]
        }] : [])

    ]),[productSubProductFields, data, getIssueTypes, name, priorities, commonSeverityProps, isEdit, form, getProjectKeys, featureFlags.UNIFIED_TICKET_TEMPLATE, getUnifiedSingleTemplates, getUnifiedMultiTemplates, featureFlags.TICKETING_CUSTOM_SEVERITY_RISK_RATING, parseJiraProjectKeyOptions]);

    const handleMarkResolveChecked = useCallback(event => {
        const checked = !data.projectKey || !data.issueType || !event.target.checked;
        setIsResolvedStatusDisabled(checked)
    }, [data.projectKey, data.issueType])

    const handleMarkReopen = useCallback(event => {
        const checked = event.target.checked;
        setMarkReopen(checked)
    }, []);

    const appendAllStatus = useCallback((opt = []) => {
        const status = form.getFieldsValue().ticketClosureStatus || [];
        opt.forEach(i => i["disabled"] = status.includes('All'));
        return [{ label: "All", value: "All" }, ...opt];
    }, [form])

    const getJiraLabels = useCallback((params) =>{
        if(!loginConfigId){
            return Promise.resolve([]);
        }
        return ToolsIntegrationsAPI.getJiraLabels({loginConfigId, ...params});
    }, [loginConfigId])

    const findingField = useMemo(() => ([
        {
            render: (props) => (<div {...props} />),
            className: 'p-y-sm',
        },
        {
            name: "markResolved",
            label: <> Close Ticket when Finding is <Vocabulary name={"mitigated"} /> <Tooltip title={<>Automatically closes {name} ticket when an issue is fixed. The other states that may trigger ticket close are {<ResolvedFindingStatusNames/>} based on the global configuration as provided <br/><Link href="#/globalsettings?activeStep=step17">Click here</Link></>}  placement="top"> <HelpIcon /> </Tooltip>
            </>,
            type: FieldTypes.BOOLEAN,
            colSpan: 12,
            inline:true,
            props: {
                onChange: handleMarkResolveChecked
            }
        },
        {
            name: "resolvedStatus",
            label: "Close Transition Name",
            help: `Close Transition Name should be set as the final (close) status in your defined ${name} workflow for your project. For example 'CLOSED', 'RESOLVED' or 'DONE'.`,
            type: FieldTypes.SELECT,
            options: transitionStatusOptions,
            required: !isResolvedStatusDisabled,
            disabled: isResolvedStatusDisabled,
            colSpan: 12,
        },
        {
            name: "markReopen",
            label: "Re-open ticket if finding remains unresolved from a scan",
            type: FieldTypes.BOOLEAN,
            colSpan: 12,
            inline:true,
            props: {
                onChange: handleMarkReopen
            },
            className:"m-t-l"
        },{
            name: "reopenStatus",
            label: "Re-open Transition Name",
            required: markReopen,
            type: FieldTypes.SELECT,
            options: transitionStatusOptions,
            disabled: !markReopen,
            colSpan: 12,
            help: <>{name} status(transition) which can be directly assigned from closed status(transition)</>,
            props: {
                allowClear: true
            },
        },
        ...(name.toLowerCase() !== 'service now' 
        ? [
        ...(featureFlags.JIRA_TICKET_CLOSURE_STATUS_SELECTION ?
            [{
            name: "ticketClosureStatus",
            label: "Ticket Closure Status",
            help: `Only close ticket when the ticket status is as defined below. By default all will be considered if nothing is selected.`,
            type: FieldTypes.MULTI_SELECT,
            options: transitionStatusOptions,
            disabled: isResolvedStatusDisabled,
            props: {
                optionsMutator: appendAllStatus,
                onChange: (val) => setAllSelected(val.includes('All'))
            },
            colSpan: 12,
        }] : [])] : []),
        ...(name.toLowerCase() !== 'service now' ? [{
            name: "labels",
            label: "Labels",
            help: `These "labels" will be added to the tickets.`,
            colSpan: 12,
            type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
            props: {
                mode: "tags",
                api: getJiraLabels,
            }, 
            rules: [
                {
                    validator:(_, values) => {
                        const regEx = /\s/;
                        if(values){
                            for(let i = 0; i < values.length; i += 1){
                                if(regEx.test(values[i])){
                                    return Promise.reject("The label can't contain blank spaces.");
                                }
                            }
                        }
                        return Promise.resolve();
                    }
                }
            ]
        }] : []), 
        ...(name.toLowerCase() !== 'service now'
        ? [{
            name: "webHookEnabled",
            label: "Sync Jira Webhook",
            type: FieldTypes.SWITCH,
            help: "Enable this to configure the Jira webhook for ticket updates. This requires admin permissions in Jira.",
            labelAlign: "left",
            inline: true,
            props: {
                onChange: setIsWebhookSync
            },
            colSpan: 12
        }] : []),
        ...(isWebhookSync
        ? [{
            name: "manualRegister",
            label: "Configure Manual Jira Webhook",
            type: FieldTypes.BOOLEAN,
            labelAlign: "left",
            inline: true,
            colSpan: 12
        }] : []),
    ]),[name, handleMarkResolveChecked, transitionStatusOptions, isResolvedStatusDisabled, featureFlags.JIRA_TICKET_CLOSURE_STATUS_SELECTION, appendAllStatus, isWebhookSync, getJiraLabels, markReopen, handleMarkReopen]);


    const transitonField = (tool) => [
        {
            name: "transitions",
            label: "Transitions",
            colSpan: 24,
            type: FieldTypes.TEXT_AREA,
            help: <> Please provide the Status workflow in JSON format. For reference, please refer to the <Typography.Link href={tool === "jira" ? "/downloads/jiraTransitions.json" : "/downloads/serviceNowTransitions.json"} download> Demo </Typography.Link> File. <br/>
            { tool === "serviceNow" && 'Note: When Closed and Resolved states are selected then the Transition field is mandatory, and the input json should be as per the transition rules given in the Service now instance used.'} </>,
            NoDefaultLengthRule: true,
            rules: [
                checkCharLimit(4000),
                {
                validator: (_, value) => {
                    if(!isEmpty(value)){
                        try{
                            JSON.parse(value);
                         }catch (e){
                            return Promise.reject(new Error('Invalid JSON Text'))
                         }
                    }
                     return Promise.resolve();
                },
            }]
        }
    ]

    const rallyFields = [
        ...productSubProductFields,
        {
            name: "organisation",
            label: "Workspace",
            type: FieldTypes.SELECT,
            colSpan: 12,
            required: true,
            props: {
                api: getWorkspaces,
                onChange:(value)=>{
                    setData({...data, organisation: value});
                }
            }
        },
        {
            name: "projectKey",
            label: "Project Key",
            colSpan: 12,
            type: FieldTypes.SELECT,
            required: true,
            props: {
                api: getProjectKeys,
                onChange: (value) => {
                    isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                    setData({...data, projectKey: value, issueType: undefined });
                    form.setFieldsValue({ issueType: undefined });
                }
            }
        }, {
            name: "issueType",
            label: "Issue Type",
            colSpan: 12,
            type: FieldTypes.SELECT,
            required: true,
            disabled: !data.projectKey,
            props: {
                api: getIssueTypes,
                parseSelectOptions: customParseSelectOptions,
                onChange: (value) =>  {
                    isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                    const markResolved = form.getFieldValue('markResolved');
                    setData({...data, issueType: value});
                    setIsResolvedStatusDisabled(!value || !markResolved);
                }
            }
        },
        {
            label: `ArmorCode Severity -> ${name} Priority`,
            type: FieldTypes.GROUP,
            fields: [{
                name: "critical",
                label: <Vocabulary name="critical"/>,
                ...commonSeverityProps
            }, {
                name: "high",
                label: <Vocabulary name="high"/>,
                ...commonSeverityProps
            }, {
                name: "medium",
                label: <Vocabulary name="medium"/>,
                ...commonSeverityProps
            }, {
                name: "low",
                label: <Vocabulary name="low"/>,
                ...commonSeverityProps
            }, {
                name: "info",
                label: <Vocabulary name="info"/>,
                ...commonSeverityProps
            }]
        },
        {
            render: (props) => (<div {...props} />),
            className: 'p-y-sm',
        },
        {
            name: "markResolved",
            label: <> Close Ticket when Finding is <Vocabulary name={"mitigated"} />  <Tooltip title={<>Automatically closes {name} ticket when an issue is fixed. The other states that may trigger ticket close are {<ResolvedFindingStatusNames/>} based on the global configuration as provided <br/><Link href="#/globalsettings?activeStep=step17">Click here</Link></>}  placement="top"> <HelpIcon /> </Tooltip>
            </>,
            type: FieldTypes.BOOLEAN,
            colSpan: 12,
            inline:true,
            props: {
                onChange: handleMarkResolveChecked
            },
            className:"m-t-l"
        },
        {
            name: "resolvedStatus",
            label: "Close Transition Name",
            help: `Close Transition Name should be set as the final (close) status in your defined ${name} workflow for your project. For example 'CLOSED', 'RESOLVED' or 'DONE'.`,
            type: FieldTypes.SELECT,
            options: transitionStatusOptions,
            required: !isResolvedStatusDisabled,
            disabled: isResolvedStatusDisabled,
            colSpan: 12,
        }
    ];

    const connectAllFields = [
        ...productSubProductFields,
        {
            name: "projectKey",
            label: "Project Key",
            colSpan: 12,
            type: FieldTypes.SELECT,
            required: true,
            props: {
                api: getProjectKeys,
                parseSelectOptions: customParseSelectOptions,
                onChange: (value) => {
                    isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                    setData({...data, projectKey: value})
                }
            }
        }
    ]

    const jiraFields = [
        ...fields,
        ...findingField,
        ...transitonField("jira")
    ];

    const serviceNowFilteredVulnerableResponseIssueTypeOptions = useMemo(() => {
        const filteredOptions = serviceNowVulnerableResponseIssueTypeOptions.filter((vulnOption) => {
            if((vulnOption.featureFlag && featureFlags[vulnOption.featureFlag]) || !vulnOption.featureFlag){
                return true;
            }
        }).map(vulnOption => ({label: vulnOption.label, value: vulnOption.value}))
        return filteredOptions;
    } , [featureFlags])

    const serviceNowFields = useMemo(() => {
        return [
            ...productSubProductFields,
            {
                    name: "projectKey",
                    label: "Module",
                    colSpan: 12,
                    type: FieldTypes.SELECT,
                    required: true,
                    options: serviceNowModulesOptions,
                    props: {
                        onChange: (value) => {
                            isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                            setData(prevData => ({...prevData, projectKey: value, issueType: undefined }));
                            form.setFieldsValue({ issueType: undefined });
                        }
                    }
                }, {
                    name: "issueType",
                    label: "Issue Type",
                    colSpan: 12,
                    type: FieldTypes.SELECT,
                    required: true,
                    ...(data.projectKey === "Vulnerability Response" ? {options: serviceNowFilteredVulnerableResponseIssueTypeOptions} : {}),
                    props: {
                        ...(data.projectKey === "incident" ? {api: getIssueTypes} : {}),
                        parseSelectOptions: customParseSelectOptions,
                        onChange: value => {
                            isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                            setData(prevData => ({...prevData, issueType: value}))
                        }
                    }
                }, ...(featureFlags.UNIFIED_TICKET_TEMPLATE ? [{
                    name: "ticketUnifiedSingleTemplateId",
                    label: "Single Finding Template",
                    colSpan: 12,
                    type: FieldTypes.SELECT,
                    props: {
                        api: getUnifiedSingleTemplates,
                    }
                }, {
                    name: "ticketUnifiedMultipleTemplateId",
                    label: "Multi-Finding Template",
                    colSpan: 12,
                    type: FieldTypes.SELECT,
                    props:{
                        api: getUnifiedMultiTemplates,
                    }
                }] : []), ...(!isServiceNowDetConfig ? [{
                    label: `ArmorCode Severity -> ${name} Priority`,
                    type: FieldTypes.GROUP,
                    className: "justify-content-center",
                    fields: [{
                        name: "critical",
                        label: <Vocabulary name="critical"/>,
                        ...commonSeverityProps
                    }, {
                        name: "high",
                        label: <Vocabulary name="high"/>,
                        ...commonSeverityProps
                    }, {
                        name: "medium",
                        label: <Vocabulary name="medium"/>,
                        ...commonSeverityProps
                    }, {
                        name: "low",
                        label: <Vocabulary name="low"/>,
                        ...commonSeverityProps
                    }, {
                        name: "info",
                        label: <Vocabulary name="info"/>,
                        placeholder: "Lowest",
                        ...commonSeverityProps
                    }]
                }] : []),
                ...(!isServiceNowDetConfig ? findingField : []),
                ...(data.projectKey === "Vulnerability Response" ? [] : [...transitonField("serviceNow")]) 
            ]
    }, [commonSeverityProps, data.projectKey, findingField, form, getIssueTypes, name, productSubProductFields, isEdit, featureFlags.UNIFIED_TICKET_TEMPLATE, getUnifiedMultiTemplates, getUnifiedSingleTemplates, serviceNowFilteredVulnerableResponseIssueTypeOptions, isServiceNowDetConfig]) 

        const fetchGitlabRepo = useCallback((params) => {
            const { promise, cancel } = ToolsIntegrationsAPI.getTicketSystemToolProjects(loginConfigId, params);

            promise.then(res => {
                repoNamesRef.current = _.uniqBy([...repoNamesRef.current, ...res], 'id');
            });

            return { promise, cancel };
        }, [loginConfigId]);

        const gitlabIssuesFields = [{
                name: "projectKey",
                label: "Repository Name",
                colSpan: 12,
                type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
                required: true,
                props: {
                    api: fetchGitlabRepo,
                    startPage: 1,
                    onChange: (value) => {
                        isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                        setData({...data, projectKey: value});
                    }
                }
            },
            ...productSubProductFields,
            {
                name: "issueType",
                label: "Issue Type",
                colSpan: 12,
                type: FieldTypes.SELECT,
                required: true,
                disabled: !data.projectKey,
                props: {
                    onChange: value => {
                        isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                        setData({...data, issueType: value})
                    }
                },
                options:[{label:"Incident",value:"incident"}, {label:"Issue",value:"issue"}]
            }, 
            {
                name: "labels",
                label: "Labels",
                help: "These labels will be added to the tickets.",
                colSpan: 12,
                type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
                props: {
                    mode: "tags",
                    api: getJiraLabels,
                }, 
                rules: [
                    {
                        validator:(_, values) => {
                            const regEx = /\s/;
                            if(values){
                                for(let i = 0; i < values.length; i += 1){
                                    if(regEx.test(values[i])){
                                        return Promise.reject("The label can't contain blank spaces.");
                                    }
                                }
                            }
                            return Promise.resolve();
                        }
                    }
                ]
            },
        ]

    const parseServiceOptions = useCallback((options)=> (
        (options || []).map(option => {
            const {
                name: label,
                id: value,
            } = option;
            return {
                label,
                value,
            }
        })
    ),[]);

    const pagerDutySeverityProps = useMemo(() => ({
        colSpan: 5,
        className: "m-b-0",
        type: FieldTypes.SELECT,
        style: {flex: "0 0 20%"},
        rules: [{
            required: true,
            message: `Select ${name} Priority`
        }],
        options: [
            {
                label: 'High',
                value: 'High'
            },
            {
                label: 'Low',
                value: 'Low'
            },
        ],
        disabled: !data.projectKey,
    }),[data.projectKey, name]);

    const pagerDutyFields = [
        ...productSubProductFields,
        {
            name: "projectKey",
            label: "Service",
            colSpan: 12,
            type: FieldTypes.SELECT,
            required: true,
            props: {
                api: ToolsIntegrationsAPI.getTicketSystemToolProjects,
                apiParams: loginConfigId,
                onChange: (value, listField, selectedOption) => {
                    isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                    projectKeyRef.current = {
                        id: selectedOption.value,
                        name: selectedOption.name
                    }
                },
            }
        }, {
            name: "defaultConfiguration",
            label: "Set as Default Service",
            inline: true,
            colSpan: 12,
            help: <>Use the PagerDuty Service as default for the given <Vocabulary name="product"/> and/or <Vocabulary name="subProduct"/> while creating tickets manually or through runbooks.</>,
            type: FieldTypes.BOOLEAN,
            className: "m-b-0 m-t-l"
        }, {
            label: `ArmorCode Severity -> ${name} Urgency`,
            type: FieldTypes.GROUP,
            className: "justify-content-center",
            fields: [{
                name: "critical",
                label: <Vocabulary name="critical"/>,
                ...pagerDutySeverityProps
            }, {
                name: "high",
                label: <Vocabulary name="high"/>,
                ...pagerDutySeverityProps
            }, {
                name: "medium",
                label: <Vocabulary name="medium"/>,
                ...pagerDutySeverityProps
            }, {
                name: "low",
                label: <Vocabulary name="low"/>,
                ...pagerDutySeverityProps
            }, {
                name: "info",
                label: <Vocabulary name="info"/>,
                placeholder: "Lowest",
                ...pagerDutySeverityProps
            }]
        }
    ]

    const armorcodeTicketingSystemFields = [
        ...productSubProductFields,
        {
            name: "projectKey",
            label: "Service",
            colSpan: 12,
            type: FieldTypes.SELECT,
            required: true,
            props: {
                api: ToolsIntegrationsAPI.getTicketSystemToolProjects,
                apiParams: loginConfigId,
                parseSelectOptions: parseServiceOptions,
                onChange: () => isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE),
            }
        }, {
            label: `ArmorCode Severity -> ${name} Priority`,
            type: FieldTypes.GROUP,
            className: "justify-content-center",
            fields: [{
                name: "critical",
                label: <Vocabulary name="critical"/>,
                ...pagerDutySeverityProps
            }, {
                name: "high",
                label: <Vocabulary name="high"/>,
                ...pagerDutySeverityProps
            }, {
                name: "medium",
                label: <Vocabulary name="medium"/>,
                ...pagerDutySeverityProps
            }, {
                name: "low",
                label: <Vocabulary name="low"/>,
                ...pagerDutySeverityProps
            }, {
                name: "info",
                label: <Vocabulary name="info"/>,
                placeholder: "Lowest",
                ...pagerDutySeverityProps
            }]
        }
    ]


    const shortcutFields = useMemo(() => ([
        ...productSubProductFields,
        {
                name: "projectKey",
                label: "Project Key",
                colSpan: 12,
                type: FieldTypes.SELECT,
                required: true,
                props: {
                    api: ToolsIntegrationsAPI.getTicketSystemToolProjects,
                    apiParams: loginConfigId,
                    parseSelectOptions: customParseSelectOptions,
                    onChange: (value) => {
                        isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                        setData({...data, projectKey: value, issueType: undefined });
                        form.setFieldsValue({ issueType: undefined });
                    }
                }
            }, {
                name: "issueType",
                label: "Issue Type",
                colSpan: 12,
                type: FieldTypes.SELECT,
                required: true,
                disabled: !data.projectKey,
                props: {
                    api: getIssueTypes,
                    parseSelectOptions: customParseSelectOptions,
                    onChange: (value) => {
                        isEdit && message.warn(CONFIG_UPDATE_WARNING_MESSAGE);
                        setData({...data, issueType: value});
                    }
                }
            }, 
        {
            name: "labels",
            label: "Labels",
            help: "These labels will be added to the tickets.",
            colSpan: 12,
            type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
            props: {
                mode: "tags",
                api: getJiraLabels,
            },
            rules: [
                {
                    validator:(_, values) => {
                        const regEx = /\s/;
                        if(values){
                            for(let i = 0; i < values.length; i += 1){
                                if(regEx.test(values[i])){
                                    return Promise.reject("The label can't contain blank spaces.");
                                }
                            }
                        }
                        return Promise.resolve();
                    }
                }
            ]
        },
    ]),[data, getIssueTypes, isEdit, loginConfigId, productSubProductFields, form, getJiraLabels]);

    const getFields = (name) => {
        let newFields = [];
        switch(name){
            case "Service Now":
                newFields = serviceNowFields;
                break;
            case "Jira":
                newFields = jiraFields;
                break;
            case "PagerDuty":
                newFields = pagerDutyFields;
                break;
            case "ARMORCODE_TICKETING_SYSTEM":
                newFields = armorcodeTicketingSystemFields;
                break;    
            case "Shortcut":
                newFields = shortcutFields;
                break;
            case "GitLab Issues":
                newFields = gitlabIssuesFields;
                break;
            case "Rally":
                newFields = rallyFields;
                break;
            case "Connect All":
                newFields = connectAllFields;
                break;
            default:
                newFields = fields;
                break;
        }
        const [field] = newFields;
        field.props = {...(field.props || {}), autoFocus: true }
        return newFields
    }

    const ToolSpecificCustomFieldWrapper = RENDER_FIELDS_V2[name];
    return (
        <BaseModal
            ref={ref}
            modalProps={modalProps}
            afterClose={props.afterClose}
        >  
            <Form 
                form={form} 
                initialValues={data} 
                layout="vertical"
                onValuesChange={onChange}
            >
                {generateFormFields(getFields(name))}
            </Form>
            {filteredIntegrations.indexOf(name) !== -1 && !isServiceNowDetConfig ? (
                ToolSpecificCustomFieldWrapper ?
                <ToolSpecificCustomFieldWrapper
                    ref={thisRef}
                    form={form}
                    loginConfigId={loginConfigId}
                    initialValues={data}
                    configId={props.config?.id}
                    changeMode={isEdit}
                    withCollapse
                    toolName={name}
                    onLoadingChange={setIsCustomFieldsLoading}
                /> :
                <RenderCustomFields form={form}
                    ref={thisRef}
                    initialValues={data}
                    loginConfigId={loginConfigId}
                    changeMode={isEdit}
                    configId={props.config?.id}
                    toolName={name}
                    onLoadingChange={setIsCustomFieldsLoading}
                />
            ) : null}
        </BaseModal>
    )
}

export default forwardRef(JiraMappingForm);

export function customParseSelectOptions(options, toolName) {
    return (options || []).map(option => {
        let { label = option, value = option} = option;
        if(_.isObject(value) && !_.isString(option)){
            label = option.name;
            value = !toolName ? option.name : toolName?.toLowerCase() === "rally" || toolName?.toLowerCase() === "version one" ? option.id : option.name;
        }
        return { ...option, label, value }
    })
}

export async function generateResponse(data, id, loginConfigId, url, toolName, customFieldsData, featureFlags = {}){
    const severities = Object.keys(SEVERITY_COLOR);
    const configValues = _.omit(data, severities);
    configValues.enabled = true;
    configValues.properties = {};
    severities.forEach(s => {
        if(data[s]){
            configValues.properties[s] = data[s];
        }
    });
    if(!isUndefined(configValues.transitions)){
        configValues.transitions = isEmpty(configValues.transitions) ? [] :JSON.parse(configValues.transitions);
    }
    configValues.ticketSystemType = toolName;
    configValues.loginConfigId = loginConfigId;
    if(url){
        configValues.url = url
    }
    const isAllProduct = configValues.product[0] === "all";
    const isAllSubproduct = configValues.subProduct[0] === "all";
    if(isAllProduct){
        delete configValues.product;
    }
    if(isAllSubproduct){
        delete configValues.subProduct;
    }
    if (isAllProduct && isAllSubproduct) {
        configValues.configurationType = "GLOBAL";
    } else if ((!isAllProduct && isAllSubproduct) || configValues.product.length > 1) {
        configValues.configurationType = "PRODUCT";
    } else {
        configValues.configurationType = "SUBPRODUCT";
    }

    if (customFieldsData) {
        const { inputCustomFields, customFieldState: fieldsChecked } = customFieldsData;
        configValues.customFields = [];
        _.forEach(inputCustomFields, cstmField =>{
            let fieldValue =  isArray(data[cstmField.key]) ? data[cstmField.key].join()  : data[cstmField.key];

            // cascadingselect: value format `parent:child`
            if(cstmField.type === "cascadingselect" && _.isArray(data[cstmField.key])){
                fieldValue = _.isUndefined(data[cstmField.key][1]) ? `${data[cstmField.key][0]}`: `${data[cstmField.key][0]}:${data[cstmField.key][1]}`;
            }
            // 
            if (cstmField.type === "datepicker" || cstmField.type === "dateTime") {
                fieldValue = moment(fieldValue).isValid() ? moment(fieldValue).format("YYYY-MM-DD") : fieldValue
            }

            //setup sevrity/priority group field payload
            if(featureFlags.TICKETING_CUSTOM_SEVERITY_RISK_RATING && CUSTOM_SEVERITY_MAPPING_SUPPORTED_TOOLS.includes(toolName.toLowerCase())){
                const mappings = getSeverityFieldMappingsPayload(cstmField, data);
                if(!isEmpty(mappings)){
                    cstmField.mappings = mappings;
                }
            }

            // if fieldValue is mismatch with defaultValue means defaultValue is from template
            const field = { ...cstmField, active: !!fieldsChecked[cstmField.key], defaultVal: fieldValue };
            if((CUSTOM_FIELDS_WITH_SEARCH.includes(cstmField.type) || CUSTOM_FIELDS_WITH_USER_API.includes(cstmField.type)) && (!isEmpty(data[cstmField.key]) && !isString(data[cstmField.key]))){
                const {fieldValue: value, selectedValues} = getCustomFieldSelectedValuesPayload(data, cstmField);
                field.defaultVal = value;
                field.selectedValues = selectedValues;
                fieldValue = value;
            }
            if(_.isBoolean(fieldValue) || !_.isEmpty(fieldValue)){
                configValues[cstmField.key] = fieldValue;
                configValues.customFields.push(field)
            }
        });
    }

    const isDefaultConfigPresent = configValues.defaultConfiguration
    return {
        configValues,
        isDefaultConfigPresent
    }
}

export const RenderCustomFields =  forwardRef(({ customFieldsValueRef, useValueField = false, form, loginConfigId, ticketConfigurationId, initialValues, configId, changeMode,  withCollapse=true, innerRef=null, renderCustomFields, fieldMessage="Please select Project Key and Issue Type", toolName, onLoadingChange, ...restProps}, ref) => {
    const initialData = useRef(initialValues);
    const [inputCustomFields, setInputCustomFields ] = useState([]);
    const [customFieldState, setCustomFieldState] = useState({});
    const [loading, setLoading] = useState(false)
    const apiParamRef = useRef({});
    const thisRef = useRef(innerRef);
    const featureFlags = useFeatureFlag();
    const isJira = toolName === "Jira";
    const checkEmptyField = value => _.isUndefined(value) || _.isNull(value);
    // Extract fetch-driving keys so the load effect can depend on stable scalars, not the full initialValues object.
    const { projectKey, issueType, issueTypeId} =  initialValues;
    const text = useMemo(() => {
        if (loading) {
            return;
        }
        const message = (!loginConfigId || (!ticketConfigurationId || initialValues.projectKey || initialValues.issueType)) ? fieldMessage : "Jira does not have any custom fields configured for this project";
        const text = (!loginConfigId || !initialValues.projectKey || !initialValues.issueType) ? message : 'No Custom Fields.';
        return <Typography.Text strong>{text}</Typography.Text>;
    }, [loginConfigId, ticketConfigurationId, initialValues, fieldMessage, loading]);

    const resetFields = useCallback(() => {
        setInputCustomFields([])
        setCustomFieldState({})
        apiParamRef.current = {};
    }, [])

    const onValuesChange = useCallback((current = {}) => {
        const customFieldValues = _.pick(current, _.map(inputCustomFields, 'key'));
        if (_.isEmpty(customFieldValues)) {
            return;
        }
        if (customFieldsValueRef) {
            customFieldsValueRef.current = {
                ...customFieldsValueRef.current,
                ...customFieldValues
            };
        }
        _.forEach(customFieldValues, (value, key) => {
            setCustomFieldState(customFieldState => ({
                ...customFieldState,
                [key]: _.isBoolean(value) ? value : !_.isEmpty(value)
            }))
        });
    }, [customFieldsValueRef, inputCustomFields]);

    useEffect(() => {
        onLoadingChange?.(loading);
    }, [loading, onLoadingChange]);

    useEffect(() => {
        if (!checkEmptyField(loginConfigId)) {
            if (projectKey && issueType) {
                setLoading(true)
                let isEdit = changeMode;
                if (isEdit && !thisRef.current) {
                    thisRef.current = true;
                    isEdit = false;
                }
                setInputCustomFields([]);
                if (!issueType) {
                    return;
                }
                // pass configId if fetching existing custom fields config
                // pass loginConfigId, issueType and project key if issueType/projectKey is changed or not in edit mode
                const params = (!configId || (isEdit && (issueType !== initialData.current?.issueType || projectKey !== initialData.current?.projectKey))) ? { loginConfigId, projectKey, issueType, ...(issueTypeId ? {issueTypeId} : {}) } : { configId };
                const { promise, cancel  } = TicketsCreationAPI.getCustomTicketFields(params);
                promise.then(({ fields }) => {
                    if (_.isArray(fields)) {
                        const customState = {};
                        fields.forEach((field) => {
                            Object.assign(field, { active: field.isRequired ? true : field.active});
                            // set false for null boolean type values
                            // required field throws validation error 
                            // when user tries to save value initially
                            // without changing the checkbox
                            if(field.isRequired && field.type === "boolean" && isNil(field.defaultVal)){
                                form.setFieldsValue({[field.key]: false})
                            }
                            if (field.active) {
                                customState[field.key] = field.active;
                                // if field.defaultVal exist, set form field value
                                if(field.defaultVal) {
                                    form.setFieldsValue({ [field.key]: field.defaultVal })
                                }
                            }
                        })
                        if (!_.isEmpty(initialData.current?.customFields)) {
                            fields.forEach((customField) => {
                                const obj = initialData.current.customFields.find(f => f.key === customField.key);
                                if (obj) {
                                    const value = useValueField ? (obj.value || '') : (obj.defaultVal || '');

                                    // check type in lowercase, since JIRA has datetime and Azure has dateTime
                                    const typeLowerCase = obj.type?.toLowerCase();
                                    const isTextField = typeLowerCase === 'textarea' || typeLowerCase === 'string' || typeLowerCase === 'html' || _.isUndefined(typeLowerCase);

                                    let fieldValue = (ALL_DATE_FIELDS.indexOf(typeLowerCase) === -1 && !isTextField && value.includes(',')) ? _.compact(value.split(',')) : value;
                                    Object.assign(customField, { defaultValue: _.isEmpty(customField.defaultValue) ? {id: fieldValue, name: fieldValue} : customField.defaultValue, active: innerRef ? obj.active : customField.active});
                                    if (customField.active) {
                                        customState[customField.key] = customField.active;
                                    }
                                    if ((typeLowerCase === 'datetime' || ALL_DATE_FIELDS.indexOf(obj.type) !== -1) && fieldValue && typeof fieldValue === 'string') {
                                        fieldValue = moment(fieldValue).isValid() ? moment(fieldValue) : fieldValue;
                                    }
                                    if (obj.type === 'boolean' && typeof fieldValue === 'string') {
                                        fieldValue = fieldValue === "true";
                                    }
                                    let _value = fieldValue;
                                    if(CUSTOM_FIELD_TYPE[customField.type] && ["option", "array", "any"].includes(customField.dataType)){
                                        _value = _.isEmpty(fieldValue) ? [] : fieldValue;
                                    } 
                                    if (customField.type === "cascadingselect"){
                                        _value = _.split(fieldValue, ":");
                                    }
                                    if (customFieldsValueRef) {
                                        customFieldsValueRef.current = {
                                            ...customFieldsValueRef.current,
                                            ...{ [customField.key]: _value }
                                        };
                                    }
                                    //get and set severity/priority form field values from custom field mappings object
                                    // based on the customField.defaultVal
                                    if(featureFlags.TICKETING_CUSTOM_SEVERITY_RISK_RATING){
                                        const isRiskRatingField = customField.defaultVal && customField.defaultVal.indexOf('finding.riskRating') !== -1;
                                        const isSeverityValueField = customField.defaultVal && customField.defaultVal.indexOf('finding.severity.value') !== -1;
                                        if(isRiskRatingField && !isEmpty(customField.mappings)){
                                            for (const riskTitleKey of CUSTOM_FIELDS_RISK_RATING_MAPPING_KEYS) {
                                                if(customField.mappings[getVocabulary(riskTitleKey)]){
                                                    form.setFieldsValue({[`${customField.key}-${getVocabulary(riskTitleKey)}`]: customField.mappings[getVocabulary(riskTitleKey)]})
                                                }
                                            }
                                        }

                                        if(isSeverityValueField && !isEmpty(customField.mappings)){
                                            for (const mappingKey in customField.mappings) {
                                                form.setFieldsValue({[`${customField.key}-${mappingKey}`]: customField.mappings[mappingKey]})
                                            }
                                        }
                                    }
                                    form.setFieldsValue({ [customField.key]: _value })

                                    // when project key or issue type changes 
                                    // for Azure board don't set custom field value if it is an Area or Iteration field
                                    if(toolName === "Azure Board" && (customField.name === "Area" || customField.name === "Iterations") && initialData.current.projectKey !== projectKey){
                                        form.setFieldsValue({ [customField.key]: undefined });
                                    }
                                }
                            });
                        }
                        setCustomFieldState(customState);
                        setInputCustomFields(fields);
                    }
                }).finally(() => setLoading(false))
                return cancel;
            } else {
                resetFields()
            }
        }
    }, [customFieldsValueRef, loginConfigId, ticketConfigurationId, form, changeMode, configId, resetFields, innerRef, useValueField, toolName, featureFlags.TICKETING_CUSTOM_SEVERITY_RISK_RATING, issueType, projectKey, issueTypeId])

    const handleCheckedChange = useCallback((checked, key) => {
        setCustomFieldState(prevState => ({
            ...prevState,
            [key]: checked
        }));
    },[]);

    const getApiParams = useCallback((loginConfigId, projectKey, fieldLabel) => {
        const newApiParams = { loginConfigId, projectKey, fieldLabel };
        if (!_.isEqual(apiParamRef.current[fieldLabel], newApiParams)) {
            apiParamRef.current[fieldLabel] = newApiParams;
        }
        return apiParamRef.current[fieldLabel];
    }, []);


    const fieldSuggestionAPI = useCallback(({ selectedValues, ...params  }) => {
        const promiseObj = TicketsCreationAPI.getCustomTicketFieldsSuggestions(params);
        promiseObj.promise = promiseObj.promise.then((suggestions) => {
            if (!isEmpty(selectedValues)) {
                suggestions = _.uniqBy([...suggestions, ...selectedValues], "id");
            }
            suggestions = stripHtml(suggestions);
            return suggestions;
        })
        return promiseObj;
    }, []);

    const ticketingUsersAPI = useCallback(({ selectedValues, ...params  }) => {
        const promiseObj = ToolsIntegrationsAPI.getTicketingUsers(params);
        promiseObj.promise = promiseObj.promise.then((users) => {
            if (!isEmpty(selectedValues)) {
                users = _.uniqBy([...users, ...selectedValues], "id");
            }
            return users;
        })
        return promiseObj;
    }, []);

    const generateCustomFields = useCallback((fields, projectKey, issueType) => {
        const customFields = fields.map((customField) => {
            const isEnabled = customFieldState?.[customField.key] ?? customField.active;

            const rules = [];
            if (customField.dataType === 'number' || ["integer", "float", "double", "decimal"].indexOf(customField.type) !== -1) {
                rules.push({
                    validator: (_rule, value) => {
                        if (value) {
                            if (value.indexOf('${') !== -1) {
                                return findingFieldValidator(_rule, value);
                            } else {
                                return !_.isNaN(+value) ? Promise.resolve() : Promise.reject('Not a number');
                            }
                        }
                        return Promise.resolve();
                    }
                });
            }

            const field = {
                name: customField.key,
                title : customField.name,
                requireField: customField.isRequired, //useed requireField ,since required key validation from form utils
                rules: [{
                    required: customField.isRequired || isEnabled,
                    message: <>{customField.name} is required</>
                }, ...rules],
                switchProps: {
                    checked: customField.isRequired || isEnabled,
                    onChange: (e) => handleCheckedChange(e, customField.key),
                    disabled: customField.isRequired
                },
                // check lowercase too, since JIRA has datetime where as Azure has dateTime
                type: CUSTOM_FIELD_TYPE[customField.type] || CUSTOM_FIELD_TYPE[customField.type.toLowerCase()],
                placeholder: isJira ? "Select Field" : customField.name,
            };

            if (field.type === FieldTypes.TEXT_AREA) { 
                field.NoDefaultLengthRule = true;
            }
            if (CUSTOM_FIELDS_WITH_OPTIONS.includes(customField.type)) {
                field.options = customField.allowedValues
                if (customField.type === "multicheckboxes" || customField.type === "radiobuttons") {
                    field.options = field.options.map((option) => {
                        return {
                            label: <span title={option.name}>{option.name}</span>,
                            value: option.id,
                            ...option,
                        }
                    });
                }
            }

            if (customField.name === "Area" || customField.name === "Iterations") {
                field.render = () => (
                        <TreeSelect
                        showSearch
                        dropdownStyle={{
                            maxHeight: 400,
                        }}
                        style={{ width: '80%' }}
                        allowClear
                        treeData={parseAreaOptions(customField.allowedValues)}
                        virtual={false}
                        treeDefaultExpandAll
                    />
                );
            }
            
            if(CUSTOM_FIELDS_WITH_SEARCH.includes(customField.type)){
                const isReferenceType = customField.type === "reference";
                if ((isReferenceType && !_.isEmpty(customField.dataType)) || !isReferenceType) {
                    if (isReferenceType) {
                        field.type = FieldTypes.SELECT_WITH_PAGINATED_DATA;
                    }

                    field.props = {
                        mode: CUSTOM_FIELDS_SINGLE_SELECTION.includes(customField.type) ? "single" : "multiple",
                        api: fieldSuggestionAPI,
                        detechAPIParamChange: true,
                        apiParams: {...getApiParams(loginConfigId, projectKey, isReferenceType ? customField.dataType : customField.name), issueType, selectedValues: customField.selectedValues },
                        labelInValue: true
                    }
                }
            }
            if(CUSTOM_FIELDS_WITH_USER_API.includes(customField.type)){
                field.props = {
                    ...(customField.type === "multiuserpicker") && {mode:"multiple"},
                    apiParams: {...getApiParams(loginConfigId, projectKey, customField.name), selectedValues: customField.selectedValues },
                    detechAPIParamChange: true,
                    api: ticketingUsersAPI,
                    labelInValue: true
                };
            }
            // check type in lowercase, since JIRA has datetime and Azure has dateTime
            if(customField.type.toLowerCase() === "datetime" || customField.type === "datepicker"){
                field.props = {
                    disabledDate: disablePastDates,
                }
            }

            if(TIME_SUPPORTED_DATE_FIELDS.indexOf(customField.type) !== -1){
                field.props = {
                    showTime: true,
                    disabledDate: disablePastDates,
                }
            }

            // check type in lowercase, since JIRA has datetime and Azure has dateTime
            if (!featureFlags.UNIFIED_TICKET_TEMPLATE && (customField.type === "datepicker" || customField.type.toLowerCase() === "datetime") && !_.isEmpty(initialValues[customField.key]) && !moment(initialValues[customField.key]).isValid()) {
                field.type = undefined;
                field.render = () => <Tooltip title="Template string is selected. Please clear template first to select date.">
                    <span><Input value={customField.defaultVal} disabled/></span>
                </Tooltip>;
            }

            if(customField.type === "HOUR_AND_MINUTE_STRING"){
                field.rules.push({validator: (rule, value) => {
                    if(!isEmpty(value)){
                        if(!/^\d+h \d+m$/.test(value)) {
                            return Promise.reject("Valid format for Planned effort is 1h 2m");
                        }
                    }
                    return Promise.resolve();
                }})
            }
            return field;
        });
        return customFields;
        
    }, [fieldSuggestionAPI, ticketingUsersAPI, customFieldState, isJira, featureFlags.UNIFIED_TICKET_TEMPLATE, initialValues, handleCheckedChange, getApiParams, loginConfigId]);
    const customField = useMemo(() => {
        return generateCustomFields(inputCustomFields, initialValues.projectKey, initialValues.issueType);
    }, [inputCustomFields, initialValues.projectKey, generateCustomFields]);

    const renderFields = useCallback((customFields) => {
        if (renderCustomFields && typeof renderCustomFields === "function") {
            return renderCustomFields(customFields);
        }
        return generateJiraCustomFields({ customFields, form, onValuesChange, showFieldHeaders: isJira, toolName});
    }, [form, isJira, onValuesChange, renderCustomFields, toolName])

    useImperativeHandle(ref,
        () => ({
            getCustomFields: () => ({inputCustomFields, customFieldState}),
            onFieldValuesChange: onValuesChange
        })
    )

    const WrapperComponent = useMemo(() => {
        const collapseProps = {};
        const CustomForm = <Form onValuesChange={onValuesChange} form={form} layout="vertical"  initialValues={initialData.current}>
                <Spin spinning={loading} indicator={<AppLoader style={{ marginTop: 0 }} />}>            
                    {
                        _.isEmpty(customField) ? text : renderFields(customField)
                    }
                </Spin>
        </Form>
        const Wrapper = withCollapse ? CustomCollapse : CustomForm;
        if (withCollapse) {
            collapseProps.header = isJira ? 
                                        <div className='d-flex flex-column'>
                                            <div>Configure Custom Fields</div>
                                            <p style={{fontSize: 12, marginTop: 4, color: "#4C5561" }}>Set the value of a ticket field with a static value or map to a finding attribute</p>
                                        </div> 
                                      : <>Configure Custom Fields <Tooltip title={
                                            restProps.tooltip || "By enabling the toggles, only those fields will be mapped to your project and the rest will be ignored. A text area and drop-down boxes allow you to add default values. These values will be considered every time you create a ticket."
                                        }> <InfoIcon /></Tooltip></>;
            collapseProps.type = "info";
            collapseProps.description = CustomForm;
            collapseProps.Key = 'custom_field';
            collapseProps.defaultActiveKey = 'custom_field'
            collapseProps.props = {destroyInactivePanel: true, className: isJira ? "no-padding" : ""}
            collapseProps.isCollapseDisabled = customField.some(field => field.requireField)
        }
        return <Wrapper {...collapseProps} />
    }, [onValuesChange, form, loading, customField, text, renderFields, withCollapse, isJira, restProps.tooltip])

    return WrapperComponent
})

export function stripHtml(options) {
    return _.map(options, option => {
        const div = document.createElement("div");
        div.innerHTML = option.name;
        const text = div.textContent || div.innerText || "";
        return ({label: text, value: option.id});
    })
}

export const serviceNowVulnerableResponseIssueTypeOptions = [{
    label: "Application Vulnerable Item", 
    value: "sn_vul_app_vulnerable_item"
}, {
    label: "Container Vulnerable Item", 
    value: "sn_vul_container_image_vulnerable_item"
}, {
    label: "Vulnerable Item", 
    value: "sn_vul_vulnerable_item"
}, {
    featureFlag: "SNOW_VR_DETECTIONS",
    label: "Vulnerable Item Detections", 
    value: "sn_vul_detection"
}];
